export default __webpack_public_path__ + "static/media/inter-400-regular.f60fc6e2.woff";